import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            let errorMessage = '';

            if (error.error instanceof ErrorEvent) {
                errorMessage = `Error: ${error.error.message}`;
            } else {
                // Catch "409 (Conflict)" responses
                if (error.status === 409) {
                    // Sign out
                    location.reload();
                } else {
                    let jsonString = `${JSON.stringify(error.error)}`;
                    let jsonObj = JSON.parse(jsonString);
                    if (
                        jsonObj.error &&
                        jsonObj.error.description &&
                        jsonObj.error.details
                    ) {
                        errorMessage = `${jsonObj.error.description} [${jsonObj.error.details}]`;
                    } else {
                        errorMessage = jsonString;
                    }
                }
            }

            return throwError(() => errorMessage);
        })
    );
};
